import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-2" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "row mb-2" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "col-2" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "col-2" }
const _hoisted_37 = {
  class: "bg-color-buttons btn-group btn-group-sm w-auto mb-3",
  role: "group",
  "aria-label": "Backgound color"
}
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-bg-color col-auto mb-2" }
const _hoisted_40 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_41 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_42 = {
  class: "bg-img-button mb-4",
  "aria-label": "Backgound Image"
}
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-bg-color col-12 mb-2" }
const _hoisted_45 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-2" }
const _hoisted_48 = { class: "col-2" }
const _hoisted_49 = { class: "col-2" }
const _hoisted_50 = { class: "col-2" }
const _hoisted_51 = { class: "col-2" }
const _hoisted_52 = { class: "row row-image mb-5" }
const _hoisted_53 = { class: "col-5" }
const _hoisted_54 = { class: "row mt-3" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "content_copy", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "content_paste", -1)
const _hoisted_58 = {
  key: 0,
  class: "text-end mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_BackgroundImageOverlaysDetail = _resolveComponent("BackgroundImageOverlaysDetail")!
  const _component_EyebrowDetail = _resolveComponent("EyebrowDetail")!
  const _component_ExtraMetadataSection = _resolveComponent("ExtraMetadataSection")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createBlock(_component_GenericFormWrapper, {
    class: "content-page-row-detail",
    pageUI: _ctx.pageUI,
    "submit-data": _ctx.submitData,
    "pinned-footer": ""
  }, {
    content: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Subtitle, {
            title: _ctx.$t('cms.container'),
            help: _ctx.$t('cms.helpTextRowContainer'),
            "help-position": "right",
            class: "mb-2"
          }, null, 8, ["title", "help"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.row.container_type_code,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.row.container_type_code) = $event)),
                _ctx.onFormDataChanged
              ],
              options: _ctx.enumContainerTypeCode,
              name: "container_type_code",
              selectText: _ctx.$t('selectText'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "options", "selectText", "errors", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Subtitle, {
            title: _ctx.$t('cms.gutters'),
            help: _ctx.$t('cms.helpTextGutters'),
            "help-position": "bottom",
            class: "mb-2"
          }, null, 8, ["title", "help"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.row.horizontal_gutter_code,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.row.horizontal_gutter_code) = $event)),
                _ctx.onFormDataChanged
              ],
              options: _ctx.enumHorizontalGutterCode,
              name: "horizontal_gutter_code",
              selectText: _ctx.$t('selectText'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "options", "selectText", "errors", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.alignmentColumns'),
                help: _ctx.$t('cms.helpTextAlignmentColumns'),
                "help-position": "right"
              }, null, 8, ["title", "help"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.items_vertical_alignment_code,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.row.items_vertical_alignment_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumItemsVerticalAlignmentCode,
                label: _ctx.$t('cms.vertical'),
                name: "items_vertical_alignment_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.items_horizontal_alignment_code,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.row.items_horizontal_alignment_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumItemsHorizontalAlignmentCode,
                label: _ctx.$t('cms.horizontal'),
                name: "items_horizontal_alignment_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.margin'),
                help: _ctx.$t('cms.helpTextMargin'),
                "help-position": "right"
              }, null, 8, ["title", "help"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.margin_top_code,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.row.margin_top_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumMarginCode,
                label: _ctx.$t('top'),
                name: "margin_top_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.margin_bottom_code,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.row.margin_bottom_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumMarginCode,
                label: _ctx.$t('bottom'),
                name: "margin_bottom_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.padding'),
                help: _ctx.$t('cms.helpTextPadding'),
                "help-position": "right"
              }, null, 8, ["title", "help"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.padding_top_code,
                "onUpdate:modelValue": [
                  _cache[6] || (_cache[6] = ($event: any) => ((_ctx.row.padding_top_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumPaddingCode,
                label: _ctx.$t('top'),
                name: "padding_top_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.row.padding_bottom_code,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.row.padding_bottom_code) = $event)),
                  _ctx.onFormDataChanged
                ],
                options: _ctx.enumPaddingCode,
                label: _ctx.$t('bottom'),
                name: "padding_bottom_code",
                selectText: _ctx.$t('selectText'),
                rules: "required",
                errors: errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.borderRadius'),
                help: _ctx.$t('cms.helpTextBorderRadius'),
                "help-position": "right"
              }, null, 8, ["title", "help"])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.row.border_radius.top_left_in_px,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.row.border_radius.top_left_in_px) = $event)),
                  _ctx.onFormDataChanged
                ],
                label: _ctx.$t('cms.topLeft'),
                name: "top_left_in_px",
                min: 0,
                rules: "required",
                errors: errors,
                mode: "group-end",
                "addon-text": "px"
              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.row.border_radius.top_right_in_px,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.row.border_radius.top_right_in_px) = $event)),
                  _ctx.onFormDataChanged
                ],
                label: _ctx.$t('cms.topRight'),
                name: "top_right_in_px",
                min: 0,
                rules: "required",
                errors: errors,
                mode: "group-end",
                "addon-text": "px"
              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.row.border_radius.bottom_left_in_px,
                "onUpdate:modelValue": [
                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.row.border_radius.bottom_left_in_px) = $event)),
                  _ctx.onFormDataChanged
                ],
                label: _ctx.$t('cms.bottomLeft'),
                name: "bottom_left_in_px",
                min: 0,
                rules: "required",
                errors: errors,
                mode: "group-end",
                "addon-text": "px"
              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.row.border_radius.bottom_right_in_px,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => ((_ctx.row.border_radius.bottom_right_in_px) = $event)),
                  _ctx.onFormDataChanged
                ],
                label: _ctx.$t('cms.bottomRight'),
                name: "bottom_right_in_px",
                min: 0,
                rules: "required",
                errors: errors,
                mode: "group-end",
                "addon-text": "px"
              }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_CssDimensionEditor, {
            modelValue: _ctx.row.min_height,
            "onUpdate:modelValue": [
              _cache[12] || (_cache[12] = ($event: any) => ((_ctx.row.min_height) = $event)),
              _ctx.onFormDataChanged
            ],
            label: _ctx.$t('cms.rowMinHeight'),
            name: _ctx.$t('cms.rowMinHeight'),
            min: 0,
            allowDisable: false,
            allowEmptyValue: true,
            errors: errors
          }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
        ])
      ]),
      _createVNode(_component_Subtitle, {
        title: _ctx.$t('cms.backgroundColor'),
        help: _ctx.$t('cms.helpTextBackgroundColor'),
        "help-position": "right",
        mb: "2"
      }, null, 8, ["title", "help"]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("button", {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleBackgroundColorType())),
          class: _normalizeClass(['btn btn-outline-primary', {'active': !_ctx.isCustomColorPanelVisible}]),
          type: "button"
        }, _toDisplayString(_ctx.$t('cms.colorStandard')), 3),
        _createElementVNode("button", {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleBackgroundColorType())),
          class: _normalizeClass(['btn btn-outline-primary', {'active': _ctx.isCustomColorPanelVisible}]),
          type: "button"
        }, _toDisplayString(_ctx.$t('cms.colorCustom')), 3)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          (_ctx.isCustomColorPanelVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_ColorPicker, {
                  modelValue: _ctx.row.background_color,
                  "onUpdate:modelValue": [
                    _cache[15] || (_cache[15] = ($event: any) => ((_ctx.row.background_color) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  label: _ctx.$t('color'),
                  name: "background_color",
                  label_bold: false
                }, null, 8, ["modelValue", "label", "onUpdate:modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.row.background_color_code,
                  "onUpdate:modelValue": [
                    _cache[16] || (_cache[16] = ($event: any) => ((_ctx.row.background_color_code) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  options: _ctx.enumBackgroundColorCode,
                  name: "background_color_code",
                  selectText: _ctx.$t('selectText'),
                  errors: errors
                }, null, 8, ["modelValue", "options", "selectText", "errors", "onUpdate:modelValue"])
              ]))
        ])
      ]),
      _createVNode(_component_Subtitle, {
        title: _ctx.$t('cms.backgroundImage'),
        help: _ctx.$t('cms.helpTextBackgroundImage'),
        "help-position": "right",
        mb: "2"
      }, null, 8, ["title", "help"]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_InputCheckboxBoolean, {
          modelValue: _ctx.isBgImgPanelVisible,
          "onUpdate:modelValue": [
            _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isBgImgPanelVisible) = $event)),
            _ctx.changeBackgroundColorVisible
          ],
          label: _ctx.$t('cms.useBackgroundImage'),
          name: "use_backgound_image_toggle",
          errors: errors
        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          (_ctx.isBgImgPanelVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.row.background_image!.horizontal_position_code,
                      "onUpdate:modelValue": [
                        _cache[18] || (_cache[18] = ($event: any) => ((_ctx.row.background_image!.horizontal_position_code) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      options: _ctx.enumBgImgHorizontalPositionCode,
                      name: "bg_img_horizontal_position",
                      label: _ctx.$t('cms.positionHorizontal'),
                      selectText: _ctx.$t('selectText'),
                      rules: "required",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.row.background_image!.vertical_position_code,
                      "onUpdate:modelValue": [
                        _cache[19] || (_cache[19] = ($event: any) => ((_ctx.row.background_image!.vertical_position_code) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      options: _ctx.enumBgImgVerticalPositionCode,
                      name: "bg_img_vertical_position",
                      label: _ctx.$t('cms.positionVertical'),
                      selectText: _ctx.$t('selectText'),
                      rules: "required",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.row.background_image!.repeat_code,
                      "onUpdate:modelValue": [
                        _cache[20] || (_cache[20] = ($event: any) => ((_ctx.row.background_image!.repeat_code) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      options: _ctx.enumBgImgRepeatCode,
                      name: "bg_img_repeat",
                      label: _ctx.$t('cms.bgImgRepeat'),
                      selectText: _ctx.$t('selectText'),
                      rules: "required",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.row.background_image!.size_code,
                      "onUpdate:modelValue": [
                        _cache[21] || (_cache[21] = ($event: any) => ((_ctx.row.background_image!.size_code) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      options: _ctx.enumBgImgSizeCode,
                      name: "bg_img_size",
                      label: _ctx.$t('cms.bgImgSize'),
                      selectText: _ctx.$t('selectText'),
                      rules: "required",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.row.background_image!.attachment_code,
                      "onUpdate:modelValue": [
                        _cache[22] || (_cache[22] = ($event: any) => ((_ctx.row.background_image!.attachment_code) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      options: _ctx.enumBgImgAttachmentCode,
                      name: "bg_img_attachment",
                      label: _ctx.$t('cms.bgImgAttachment'),
                      selectText: _ctx.$t('selectText'),
                      rules: "required",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_InputImage, {
                      "onUpdate:modelValue": _ctx.setImageKey,
                      onImageCleared: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setImageKey(null))),
                      modelValue: _ctx.existingDocumentKey,
                      typeCode: _ctx.docType,
                      module: _ctx.DpModuleEnum.CMS
                    }, null, 8, ["onUpdate:modelValue", "modelValue", "typeCode", "module"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_BackgroundImageOverlaysDetail, {
                      modelValue: _ctx.row.background_image!.overlays,
                      "onUpdate:modelValue": [
                        _cache[24] || (_cache[24] = ($event: any) => ((_ctx.row.background_image!.overlays) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      name: _ctx.$t('cms.overlays'),
                      errors: errors
                    }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_ExtraMetadataSection, {
        id: "content_page_row",
        activeLabels: _ctx.activeMetadataLabels,
        prefix: _ctx.$t('cms.advancedStyling'),
        class: "mb-4"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_EyebrowDetail, {
            key: `eyebrow_${_ctx.metadataRevision}`,
            modelValue: _ctx.row.eyebrow,
            "onUpdate:modelValue": [
              _cache[25] || (_cache[25] = ($event: any) => ((_ctx.row.eyebrow) = $event)),
              _ctx.onFormDataChanged
            ],
            errors: errors
          }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"]))
        ]),
        _: 2
      }, 1032, ["activeLabels", "prefix"])
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-icon btn-green",
        onClick: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCopyRowMetadata && _ctx.onCopyRowMetadata(...args)), ["prevent"]))
      }, [
        _hoisted_56,
        _createTextVNode(_toDisplayString(_ctx.$t('cms.metadataCopy')), 1)
      ]),
      (_ctx.getClipboardContentPageRow)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-icon btn-green",
            onClick: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPasteRowMetadata && _ctx.onPasteRowMetadata(...args)), ["prevent"]))
          }, [
            _hoisted_57,
            _createTextVNode(_toDisplayString(_ctx.$t('cms.metadataPaste')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_base_offcanvas_button_close, { class: "btn btn-light" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
        ]),
        _: 1
      })
    ]),
    belowButtons: _withCtx(() => [
      (_ctx.AuthContext.isDpUser())
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _createElementVNode("code", null, "[data-dp-cid=\"" + _toDisplayString(_ctx.contentId) + "\"]", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["pageUI", "submit-data"]))
}